import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * EAA-1804: generalises the Directory-page summary stat card (EAA-1784) into
 * a reusable primitive. It renders the exact same `portal-console-stat*`
 * classes the Directory page already ships (see global.css ~L1071), so any
 * screen adopting this component gets zero new CSS and zero visual change.
 * Renders a `Link` when `to` is given (the clickable card pattern used on
 * `/console`), otherwise a plain `div` for a static, non-navigable metric.
 */
export function MetricCard({
    label,
    value,
    valueSuffix,
    sub,
    tone = 'default',
    to,
    trend,
}: {
    label: string;
    value: string | number;
    valueSuffix?: ReactNode;
    sub?: ReactNode;
    tone?: 'default' | 'ok' | 'alert';
    to?: string;
    trend?: ReactNode;
}) {
    const className =
        'portal-console-stat' +
        (tone === 'ok' ? ' is-ok' : '') +
        (tone === 'alert' ? ' is-alert' : '');

    const content = (
        <>
            <span className="portal-console-stat-num">
                {value}
                {valueSuffix !== undefined && <small>{valueSuffix}</small>}
            </span>
            <span className="portal-console-stat-label">{label}</span>
            {trend}
            {sub !== undefined && <span className="portal-console-stat-sub">{sub}</span>}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={className}>
                {content}
            </Link>
        );
    }
    return <div className={className}>{content}</div>;
}
